
import {defineComponent, onMounted, onUnmounted, ref, watch} from 'vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {FontAwesomeIcon},
	emits: ['open', 'close'],
	expose: ['toggle'],
	setup(props, context) {
		const closeBtn = ref<HTMLButtonElement>();
		const isOpen = ref(false);
		const toggle = (force?: boolean) => isOpen.value = force ?? !isOpen.value;
		watch(isOpen, async value => {
			if (value) context.emit('open');
			else context.emit('close');
		});

		const escListener = (event: KeyboardEvent) => {
			if (isOpen.value && event.key === 'Escape')
				isOpen.value = false;
		};

		onMounted(() => document.addEventListener('keydown', escListener));
		onUnmounted(() => document.removeEventListener('keydown', escListener));

		return {
			closeBtn,
			isOpen,
			toggle,
		};
	},
});
